import {Image} from "@pg-design/image-module";
import {useUserDevice} from "@pg-mono/user-device";

import {gtmHeroBanerClick} from "../../tracking/google_tag_manager/gtm_hero_banner";
import {TdaDesktopWrap} from "../components/TdaDesktopWrap";
import {TdaMobileWrap} from "../components/TdaMobileWrap";
import {tdaMobileImageHolder} from "../styles/tda_mobile_image_holder";
import {ITdaCreation} from "../types/ITdaCreation";

interface IProps {
    creation: ITdaCreation;
    url: string;
    preventGtmOnMobile?: boolean;
}

export function TdaCreation(props: IProps) {
    const {creation, preventGtmOnMobile, url} = props;

    const {isMobile} = useUserDevice();

    const onRedirectToUrlClick = () => {
        if (!preventGtmOnMobile || !isMobile) {
            gtmHeroBanerClick();
        }

        window.open(url, "_blank");
    };

    if (isMobile) {
        return (
            <TdaMobileWrap>
                <Image
                    onClick={onRedirectToUrlClick}
                    css={tdaMobileImageHolder}
                    imageStyle={{objectFit: "fill", height: "100%"}}
                    alt={creation.name}
                    width="375px"
                    height="484px"
                    ratio={{xs: "375/484"}}
                    src={creation.mobile_image?.m_img_375x484}
                    src2x={creation.mobile_image?.m_img_750x968}
                    src3x={creation.mobile_image?.m_img_750x968}
                />
            </TdaMobileWrap>
        );
    }

    return (
        <TdaDesktopWrap backgroundColor={creation.background_color}>
            <Image
                onClick={onRedirectToUrlClick}
                alt={creation.name}
                width="1100px"
                height="220px"
                src={creation.desktop_image.d_img_1100x220}
                src2x={creation.desktop_image.d_img_2200x440}
                src3x={creation.desktop_image.d_img_3300x660}
            />
        </TdaDesktopWrap>
    );
}
import {Image} from "@pg-design/image-module";
import {useUserDevice} from "@pg-mono/user-device";

import {gtmHeroBanerClick} from "../../tracking/google_tag_manager/gtm_hero_banner";
import {TdaDesktopWrap} from "../components/TdaDesktopWrap";
import {TdaMobileWrap} from "../components/TdaMobileWrap";
import {tdaMobileImageHolder} from "../styles/tda_mobile_image_holder";
import {ITdaCreation} from "../types/ITdaCreation";

interface IProps {
    creation: ITdaCreation;
    url: string;
    preventGtmOnMobile?: boolean;
}

export function TdaCreation(props: IProps) {
    const {creation, preventGtmOnMobile, url} = props;

    const {isMobile} = useUserDevice();

    const onRedirectToUrlClick = () => {
        if (!preventGtmOnMobile || !isMobile) {
            gtmHeroBanerClick();
        }

        window.open(url, "_blank");
    };

    if (isMobile) {
        return (
            <TdaMobileWrap>
                <Image
                    onClick={onRedirectToUrlClick}
                    css={tdaMobileImageHolder}
                    imageStyle={{objectFit: "fill", height: "100%"}}
                    alt={creation.name}
                    width="375px"
                    height="484px"
                    ratio={{xs: "375/484"}}
                    src={creation.mobile_image?.m_img_375x484}
                    src2x={creation.mobile_image?.m_img_750x968}
                    src3x={creation.mobile_image?.m_img_750x968}
                />
            </TdaMobileWrap>
        );
    }

    return (
        <TdaDesktopWrap backgroundColor={creation.background_color}>
            <Image
                onClick={onRedirectToUrlClick}
                alt={creation.name}
                width="1100px"
                height="220px"
                src={creation.desktop_image.d_img_1100x220}
                src2x={creation.desktop_image.d_img_2200x440}
                src3x={creation.desktop_image.d_img_3300x660}
            />
        </TdaDesktopWrap>
    );
}
